






import { PageConfig } from '@/store/modules/PageConfigs'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class FileViewerGo extends Vue {
  @Prop() fileSrc!: string
  @Prop() pageConfig!: PageConfig

  get url (): string {
    // TODO: FIXME:
    return `https://pcleonov-m710q.office.ki-wi.cz:5678/api/v1/viewer?file=${encodeURIComponent(this.fileSrc)}`
  }
}
